import React, { useState, useRef, useContext, useEffect } from 'react';
import { ModalDialog, Dialog } from '../dialog/index.js';
import { ExerciseIframe } from './exercise-iframe.js';
import { BearerTokenGetterContext } from '../../context/BearerTokenGetterContext.js';
import { reviewExerciseSession } from './util/exercises-api.js';
import { ExerciseLoading } from './states/exercise-loading.js';
import { MediaLinkDialogHeader } from '../media-link-dialog-header/index.js';
import img from '../../assets/images/p_logo.svg.js';
import styles from './exercise-dialog.module.css.js';
import useAnalytics from '../../hooks/useAnalytics.js';
import { ANALYTICS_EVENT_TYPES } from '../../hooks/constants/Analytics.js';

const ReviewDialog = ({ medialink, sessionId, onClose, superModuleHasExerciseEntrance, analyticsData, translations, studioGroup, }) => {
    const [url, setUrl] = useState();
    const [serviceAvailable, setServiceAvailable] = useState(true);
    const eventCaptured = useRef(false);
    const { id: medialinkId, moduleId } = medialink;
    const getBearerToken = useContext(BearerTokenGetterContext);
    const analytics = useAnalytics();
    useEffect(() => {
        const run = async () => {
            const token = await getBearerToken();
            try {
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                const { reviewUrl } = await reviewExerciseSession(token, moduleId, medialinkId, sessionId, studioGroup);
                setUrl(reviewUrl);
            }
            catch (err) {
                setServiceAvailable(false);
            }
        };
        run();
    }, [getBearerToken, medialinkId, moduleId, sessionId, studioGroup]);
    useEffect(() => {
        const captureEvent = async () => {
            const token = await getBearerToken();
            if (analyticsData && token && !eventCaptured.current) {
                eventCaptured.current = true;
                analytics.capture({
                    eventType: ANALYTICS_EVENT_TYPES.MEDIALINK_ACCESSED,
                    objectId: medialinkId,
                    analyticsData,
                }, token);
            }
        };
        captureEvent();
    }, [analytics, analyticsData, getBearerToken, medialinkId]);
    return (React.createElement(ModalDialog, { id: 'review-dialog', closeTitle: translations.closeDialog, onClose: onClose, fullScreen: true, className: styles.dialog },
        React.createElement(MediaLinkDialogHeader, { mediaLink: medialink, superModuleHasExerciseEntrance: superModuleHasExerciseEntrance, translations: {
                generalNode: translations.generalNode,
                close: translations.closeDialog,
            }, studioGroup: studioGroup }),
        React.createElement(Dialog.Body, null, !serviceAvailable ? (React.createElement("div", { className: styles['service-not-available'] },
            React.createElement("img", { src: img, alt: 'P logo', width: '180', height: '180' }),
            React.createElement("h1", { className: 'heading' }, translations.serviceNotAvailable.title),
            React.createElement("p", null, translations.serviceNotAvailable.p1),
            React.createElement("p", null, translations.serviceNotAvailable.p2))) : (React.createElement(React.Fragment, null, url ? (React.createElement(ExerciseIframe, { exerciseUrl: url, medialink: medialink, onExerciseFinished: onClose })) : (React.createElement(ExerciseLoading, null, translations.loading)))))));
};

export { ReviewDialog };
